var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('OCColumn',{staticClass:"dashboard-container bridge-call"},[_c('OTitle',[_vm._v("Bridge Call")]),_c('CShareThisFollow'),(!_vm.isActive)?_c('CVerifyEmail'):_vm._e(),(_vm.isActive)?_c('CFormVoiceChanger'):_vm._e(),_c('CAdSecondNumber')],1)}
var staticRenderFns = []

export { render, staticRenderFns }